import React, { useEffect, useState } from "react";
import { Card, Modal } from 'antd';
import { getUser, deleteUserImage } from "../features/cutomers/customerSlice";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
const { Meta } = Card;
const Profile = () => {

    const dispatch = useDispatch();
    const { id } = useParams();
    useEffect(() => {
        dispatch(getUser(id));
    }, [dispatch, id]);

    const { customer } = useSelector((state) => state.customer);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    const containerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
    };

    const cardStyle = {
        width: '100%',
        maxWidth: '750px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
    };

    const showDeleteConfirm = (index) => {
        setDeleteIndex(index);
        setIsModalVisible(true);
    };

    const handleDeleteConfirm = () => {
        setIsModalVisible(false);
        dispatch(deleteUserImage({ id: id, data: { index: deleteIndex } }));
    };

    const handleDeleteCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <div style={containerStyle}>
            <Card
                hoverable
                style={cardStyle}
                cover={
                    <img 
                        alt="profile" 
                        src={customer?.profile_pic_url} 
                        style={{ width: '100%', height: '500px', objectFit: 'contain' }}
                    />
                }
            >
                <Meta
                    title={`${customer?.first_name} ${customer?.last_name}`}
                    description={customer?.bio}
                />
                <p><b>Age</b> :  {customer?.age}</p>
                <p><b>Gender</b> :  {customer?.gender}</p>
                <p><b>Bio</b> :  {customer?.bio}</p>
                <p><b>Phone</b> :  {customer?.phone}</p>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: '16px',
                    width: '100%',
                    marginTop: '20px'
                }}>
                    {customer?.images?.map((image, index) => (
                        <div key={index} style={{
                            position: 'relative',
                            paddingBottom: '100%',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                            <div 
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    cursor: 'pointer'
                                }}
                                onClick={() => window.open(image, '_blank')}
                            >
                                <img 
                                    src={image} 
                                    alt={`${index}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        borderRadius: '8px'
                                    }}
                                />
                            </div>
                            <button 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    showDeleteConfirm(index);
                                }}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '0px',
                                    backgroundColor: 'red',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '30px',
                                    height: '30px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    zIndex: 10,
                                    opacity: 0.8,
                                    transition: 'opacity 0.2s'
                                }}
                                onMouseEnter={(e) => e.target.style.opacity = '1'}
                                onMouseLeave={(e) => e.target.style.opacity = '0.8'}
                            >
                                ×
                            </button>
                        </div>
                    ))}
                </div>
            </Card>
            <Modal 
                title="Delete Image" 
                open={isModalVisible} 
                onOk={handleDeleteConfirm} 
                onCancel={handleDeleteCancel}
                okText="Delete"
                cancelText="Cancel"
                okButtonProps={{ danger: true }}
            >
                <p>Are you sure you want to delete this image? This action cannot be undone.</p>
            </Modal>
        </div>
    );
};

export default Profile;
